import video from "./components/video";
import slider from "./components/slider";
import home from "./components/home";
import number from "./components/number";
import { Paging } from "./components/paging";
import { projects } from "./components/projects";
import { actualites } from "./components/actualites";
import { formulaires } from "./components/formulaires";
import { Header } from "./components/header";
import { ajustBlocs } from "./components/ajustBlocs";
import keyNumbers from "./components/keyNumbers";
import gouvernance from "./components/gouvernance";
import AOS from "aos";
import { intro } from "./components/intro";

const main = {
  init: function() {
    // init AOS
    window.addEventListener("DOMContentLoaded", () => {
      AOS.init();
    });



    // Home
    home.init();
    // components flexible   ( repeat inside a page)
    intro.init(true)
    video.init(true);
    slider.init(true);

    // affichage de la liste des projets
    projects.init();

    // list des actualités
    actualites.init();

    // animations
    number.init(true);

    // Gestion des formulaires
    formulaires.init();

    // gestion du header
    Header.init();

    // Ajuste les blos entre eux
    ajustBlocs.init();

    keyNumbers.init();
    gouvernance.init();
  }
};

export default main;
